window.Products.Clothing.BoxerBriefs = function() {
};
window.Products.Clothing.BoxerBriefs.inherits(window.Products.Clothing.Clothing);

window.Products.Clothing.BoxerBriefs.id = 80;
window.Products.Clothing.BoxerBriefs.slug = 'boxer-briefs';
window.Products.Clothing.BoxerBriefs.has_3d = true;
window.Products.Clothing.BoxerBriefs.dpi = 150;
window.Products.Clothing.BoxerBriefs.use_glb = true;

window.Products.Clothing.BoxerBriefs.prototype.set3dProperties = function(modelViewer) {
	// Peachskin in, Elastic, Peachskin, Elastic in
	this.updateThreeTexture(modelViewer);
	modelViewer.camera.position.z =  1.7;
	modelViewer.initalCameraPosition.z = -1.7;

	modelViewer.object.children[0].children[0].material.transparent = true;
	modelViewer.object.children[0].children[0].material.opacity = 0.5;
	modelViewer.object.children[0].children[2].material.side = THREE.DoubleSide;
};

window.Products.Clothing.BoxerBriefs.prototype.setThreeControls = function(controls) {
	controls.minDistance = 2.5;
	controls.maxDistance = 4;
};

window.Products.Clothing.BoxerBriefs.prototype.updateThreeTexture = function(modelViewer) {
	modelViewer.texture.flipY = false;
	modelViewer.object.children[0].children[1].material.map = modelViewer.texture;
	modelViewer.object.children[0].children[2].material.map = modelViewer.texture;
};